import couple3 from "../../images/couple/2.png";
import Sectiontitle from "../section-title";
import "./style.css";

const couple1 =
  "https://lh3.googleusercontent.com/d/1wJi-v9E_a_n0PGGkHqBDo1FQRapRp9hc=w800";
const couple2 =
  "https://lh3.googleusercontent.com/d/1AdvcO5DqhcvBfrGat4Q62u64Bt1rYP0Z=w800";

const Couple = () => {
  return (
    <div id="couple" className="about-wrap">
      <div className="couple-area section-padding pb-70">
        <Sectiontitle section={"Chúng mình"} />
        <div className="container">
          <div className="couple-wrap">
            <div className="row">
              <div className="col-lg-5 col-md-12 col-sm-12 couple-single">
                <div className="couple-wrap couple-wrap-2">
                  <div className="couple-img">
                    <img
                      src="https://lh3.googleusercontent.com/d/17utCBuMadn-iURgw19jeZbwVFP02wmRQ=w800"
                      alt="thumb"
                    />
                  </div>
                  <div className="couple-text">
                    <div className="couple-content">
                      <h3>Trần Ngọc Linh Phương</h3>
                      <p>
                        Xin chào, mình là Linh Phương.
                        <br /> Sau hành trình yêu thương đầy ắp kỷ niệm,
                        <br className="d-none d-md-block" /> tụi mình đã chính thức về chung một nhà vào ngày <b>26.02.2026</b>.
                        <br /> Cảm ơn tình cảm và những lời chúc phúc ấm áp của tất cả mọi người!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 couple-single">
                <div className="couple-shape">
                  <img src={couple3} alt="shape" />
                </div>
              </div>
              <div className="col-lg-5 col-md-12 col-sm-12 couple-single">
                <div className="couple-wrap couple-wrap-3">
                  <div className="couple-img couple-img-2">
                    <img
                      src="https://lh3.googleusercontent.com/d/1_EQUEN1VEoHasF2LmkIsfBcXLJkGsH-2=w800"
                      alt="thumb"
                      className="object-fit: fill"
                    />
                  </div>
                  <div className="couple-text">
                    <div className="couple-content">
                      <h3>Trần Huy Hanh</h3>
                      <p>
                        Chào bạn, mình là Huy Hanh. <br />
                        Thật hạnh phúc khi cùng Linh Phương
                        <br className="d-none d-md-block" /> bắt đầu mái ấm nhỏ và viết tiếp cuốn nhật ký chung đôi.
                        <br /> Cảm ơn bạn đã luôn là một phần thật đẹp trong câu chuyện của hai đứa!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Couple;
